import { SVGAttributes } from 'react'

export const CircleTickIcon = (
  props: SVGAttributes<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 64 64'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z'
      fill='#AF231C'
    />
    <path
      d='M27.7185 48.3404C27.1764 48.3404 26.6416 48.2142 26.1567 47.9716C25.6718 47.7291 25.2501 47.377 24.9249 46.9431L16.3595 35.522C16.0841 35.1551 15.8837 34.7376 15.7697 34.2932C15.6557 33.8488 15.6304 33.3863 15.6952 32.9321C15.7599 32.478 15.9136 32.041 16.1473 31.6462C16.381 31.2514 16.6902 30.9066 17.0572 30.6313C17.4242 30.3561 17.8418 30.1558 18.2862 30.042C18.7307 29.9282 19.1931 29.9031 19.6473 29.9681C20.1014 30.0331 20.5383 30.187 20.9329 30.4209C21.3276 30.6548 21.6723 30.9641 21.9474 31.3313L27.5511 38.8027L41.9436 17.2133C42.4576 16.4431 43.2565 15.9086 44.1645 15.7272C45.0725 15.5459 46.0154 15.7325 46.7858 16.2462C47.5562 16.7598 48.0912 17.5584 48.273 18.4663C48.4548 19.3743 48.2687 20.3173 47.7554 21.088L30.6247 46.7851C30.3148 47.2498 29.898 47.6335 29.4093 47.9039C28.9205 48.1744 28.3741 48.3236 27.8157 48.3393C27.7833 48.3399 27.7509 48.3404 27.7185 48.3404Z'
      fill='#F2F2F2'
    />
  </svg>
)

export const CircleMailIcon = (
  props: SVGAttributes<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 64 64'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z'
      fill='#AF231C'
    />
    <path
      d='M47.6004 21.8418V42.1581C47.6005 42.3486 47.5629 42.5374 47.49 42.7135C47.4171 42.8896 47.3102 43.0495 47.1755 43.1843C47.0407 43.3191 46.8807 43.426 46.7046 43.4989C46.5285 43.5718 46.3398 43.6093 46.1492 43.6092H17.8516C17.661 43.6093 17.4722 43.5718 17.2962 43.4989C17.1201 43.426 16.9601 43.3191 16.8253 43.1843C16.6906 43.0495 16.5837 42.8896 16.5108 42.7135C16.4379 42.5374 16.4004 42.3486 16.4004 42.1581V21.8418C16.3995 21.6758 16.429 21.511 16.4875 21.3556C16.5743 21.1077 16.7274 20.8883 16.9301 20.7214C17.1329 20.5544 17.3776 20.4463 17.6375 20.4088C17.7083 20.3972 17.7799 20.3911 17.8516 20.3906H46.1492C46.2209 20.3911 46.2925 20.3972 46.3632 20.4088C46.6232 20.4463 46.8679 20.5544 47.0707 20.7214C47.2734 20.8883 47.4265 21.1077 47.5132 21.3556C47.5718 21.511 47.6013 21.6758 47.6004 21.8418Z'
      fill='white'
    />
    <path
      d='M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z'
      fill='#AF231C'
    />
    <path
      d='M47.6004 21.8418V42.1581C47.6005 42.3486 47.5629 42.5374 47.49 42.7135C47.4171 42.8896 47.3102 43.0495 47.1755 43.1843C47.0407 43.3191 46.8807 43.426 46.7046 43.4989C46.5285 43.5718 46.3398 43.6093 46.1492 43.6092H17.8516C17.661 43.6093 17.4722 43.5718 17.2962 43.4989C17.1201 43.426 16.9601 43.3191 16.8253 43.1843C16.6906 43.0495 16.5837 42.8896 16.5108 42.7135C16.4379 42.5374 16.4004 42.3486 16.4004 42.1581V21.8418C16.3995 21.6758 16.429 21.511 16.4875 21.3556C16.5743 21.1077 16.7274 20.8883 16.9301 20.7214C17.1329 20.5544 17.3776 20.4463 17.6375 20.4088C17.7083 20.3972 17.7799 20.3911 17.8516 20.3906H46.1492C46.2209 20.3911 46.2925 20.3972 46.3632 20.4088C46.6232 20.4463 46.8679 20.5544 47.0707 20.7214C47.2734 20.8883 47.4265 21.1077 47.5132 21.3556C47.5718 21.511 47.6013 21.6758 47.6004 21.8418Z'
      fill='white'
    />
    <path
      d='M47.514 21.5328L32.4328 34.8532C32.3086 34.9649 32.157 35.0254 32.0011 35.0254C31.8452 35.0254 31.6936 34.9649 31.5694 34.8532L16.4883 21.5328C16.575 21.2386 16.7281 20.9783 16.9309 20.7802C17.1336 20.5821 17.3783 20.4537 17.6383 20.4092L32.0011 33.0923L46.364 20.4092C46.6239 20.4537 46.8686 20.582 47.0714 20.7801C47.2742 20.9783 47.4273 21.2386 47.514 21.5328Z'
      fill='#AF231C'
      stroke='#AF231C'
    />
  </svg>
)

export const CircleHeartIcon = (
  props: SVGAttributes<SVGSVGElement>
): JSX.Element => (
  <svg
    width='97'
    height='64'
    viewBox='0 0 97 64'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M94.7617 36C94.7617 46.2173 86.479 54.5 76.2617 54.5C66.0445 54.5 57.7617 46.2173 57.7617 36C57.7617 25.7827 66.0445 17.5 76.2617 17.5C86.479 17.5 94.7617 25.7827 94.7617 36Z'
      fill='white'
      stroke='#AF231C'
      strokeWidth='3'
    />
    <path
      d='M86.3553 38.2896C87.8599 32.7419 84.5722 27.0276 79.012 25.5264C73.4519 24.0252 67.7248 27.3056 66.2203 32.8533C64.7158 38.4011 68.0035 44.1154 73.5636 45.6166C79.1237 47.1178 84.8508 43.8374 86.3553 38.2896Z'
      fill='white'
    />
    <path
      d='M82.0012 29.6041L76.8874 33.123L73.361 28.0203C72.7902 27.1942 71.6563 26.9864 70.8285 27.556C70.0007 28.1257 69.7924 29.2571 70.3632 30.0831L73.8896 35.1858L68.7757 38.7048C67.9485 39.2752 67.7412 40.4068 68.3128 41.2322C68.8837 42.0566 70.0157 42.2641 70.8429 41.696L75.9568 38.1771L79.4831 43.2798C80.0548 44.1053 81.1888 44.3121 82.0161 43.7417C82.8422 43.1721 83.0502 42.0425 82.4809 41.217L78.9546 36.1143L84.0684 32.5954C84.8962 32.0257 85.1045 30.8943 84.5337 30.0683C83.9629 29.2423 82.829 29.0344 82.0012 29.6041Z'
      fill='#AF231C'
    />
    <path
      d='M32.8359 64C50.5091 64 64.8359 49.6731 64.8359 32C64.8359 14.3269 50.5091 0 32.8359 0C15.1628 0 0.835938 14.3269 0.835938 32C0.835938 49.6731 15.1628 64 32.8359 64Z'
      fill='#AF231C'
    />
    <path
      d='M30.5784 21.2008C28.2589 19.757 25.459 19.2915 22.7947 19.9066C20.1305 20.5217 17.8201 22.1671 16.3719 24.4807C14.9237 26.7943 14.4562 29.5867 15.0723 32.2436C15.6885 34.9005 17.3378 37.2041 19.6574 38.6479L19.6999 38.6742L36.3697 48.9937C36.8387 49.284 37.454 49.1404 37.7452 48.6727L48.0968 32.0456C49.5303 29.7287 49.9842 26.9397 49.359 24.29C48.7338 21.6404 47.0806 19.3463 44.7617 17.9108C42.4429 16.4753 39.6476 16.0155 36.9889 16.6322C34.3301 17.249 32.0249 18.8919 30.5784 21.2008Z'
      fill='white'
    />
  </svg>
)
